import {useMemo} from 'react';
import {TrashIcon, PlusIcon} from '@heroicons/react/24/outline';
import Button from '../../../../../components/Button';
import Input from '../../../../../components/_form/Input';
import ItemRow from './InvoiceItemRow';
import {currencyFormat} from '../../../../../utils/currency';

const InvoiceCategory = ({
  category,
  onUpdate,
  onRemove,
  onAddItem,
  onRemoveItem,
  onUpdateItem,
}) => {
  const subtotal = useMemo(
    () =>
      category.items.reduce((sum, item) => {
        const qty = Number(item.quantity) || 0;
        const unit = Number(item.unitPrice) || 0;
        const labor = item.laborIncluded ? Number(item.laborPrice) || 0 : 0;
        const profit = item.profitAmount ? Number(item.profitAmount) || 0 : 0;
        return sum + qty * unit + labor + profit;
      }, 0),
    [category.items],
  );

  return (
    <div className="border rounded-lg bg-white shadow-sm">
      <div className="flex items-center justify-between p-4">
        <div className="flex-1">
          <Input
            label="Category"
            value={category.name}
            onChange={(e) => onUpdate({...category, name: e.target.value})}
            placeholder="Add category name"
          />
        </div>
        <div className="flex items-center gap-2 ml-4">
          <button
            type="button"
            className="text-red-600 hover:text-red-800"
            onClick={() => onRemove(category)}>
            <TrashIcon className="w-5 h-5" />
          </button>
        </div>
      </div>

      <div className="flex flex-col gap-4 px-4 pb-4">
        <h3 className="text-sm font-semibold">Items</h3>
        {category.items.map((item) => (
          <ItemRow
            key={item.id}
            item={item}
            onChange={(next) => onUpdateItem(category, next)}
            onToggleLabor={() =>
              onUpdateItem(category, {
                ...item,
                laborIncluded: !item.laborIncluded,
              })
            }
            onDelete={() => onRemoveItem(category, item)}
          />
        ))}
      </div>

      <div className="flex justify-center w-full pt-2 pb-4">
        <Button
          type="button"
          variant="secondary"
          onClick={() => onAddItem(category)}>
          <PlusIcon className="w-4 h-4 mr-2" />
          Add item
        </Button>
      </div>

      <div className="flex justify-end px-4 py-2 border-t">
        <span className="text-sm text-gray-600">
          Category Subtotal: {currencyFormat(subtotal)}
        </span>
      </div>
    </div>
  );
};

export default InvoiceCategory;
